var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.345,
    height: 12.876,
    viewBox: "0 0 17.345 12.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#22313f;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-miterlimit:10;}.c,.f{fill:#22313f;}.e,.f{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3309.86 -3248.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3310.362 3248.559)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M172.751,50.741a2.522,2.522,0,1,1-5.025,0,2.522,2.522,0,1,1,5.025,0Z",
    transform: "translate(-164.757 -48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M69.479,304c-2.484,0-5,1.37-5.471,3.957a.48.48,0,0,0,.447.611H74.5a.48.48,0,0,0,.447-.611C74.484,305.37,71.963,304,69.479,304Z",
    transform: "translate(-63.998 -296.692)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3320.327 3253.96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.654 2.725)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M287.888,337.3h-2.673a.515.515,0,1,0,0,1.029h2.673a.515.515,0,1,0,0-1.029Z",
    transform: "translate(-284.7 -337.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3.439,0A3.439,3.439,0,1,1,0,3.439,3.439,3.439,0,0,1,3.439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 3.439058780670166 0.9999985694885254 C 2.09415864944458 0.9999985694885254 0.9999985694885254 2.09415864944458 0.9999985694885254 3.439058780670166 C 0.9999985694885254 4.783958435058594 2.09415864944458 5.878118515014648 3.439058780670166 5.878118515014648 C 4.23417854309082 5.878118515014648 4.97299861907959 5.500868797302246 5.415739059448242 4.868518829345703 C 5.722548484802246 4.430829048156738 5.878118515014648 3.949888706207275 5.878118515014648 3.439058780670166 C 5.878118515014648 2.09415864944458 4.783958435058594 0.9999985694885254 3.439058780670166 0.9999985694885254 M 3.439058780670166 -1.430511474609375e-06 C 5.338398933410645 -1.430511474609375e-06 6.878118991851807 1.539718627929688 6.878118991851807 3.439058780670166 C 6.878118991851807 4.17219877243042 6.648708820343018 4.85175895690918 6.234598636627197 5.442518711090088 C 5.635878562927246 6.297648906707764 4.605258941650391 6.878118991851807 3.439058780670166 6.878118991851807 C 1.539718627929688 6.878118991851807 -1.430511474609375e-06 5.338398933410645 -1.430511474609375e-06 3.439058780670166 C -1.430511474609375e-06 1.539718627929688 1.539718627929688 -1.430511474609375e-06 3.439058780670166 -1.430511474609375e-06 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.8a38e5327dd178a0c955db80a152b0b0.svg";
export { ForwardRef as ReactComponent };